/* Assistant de vente (section to-assistant) : bulle, fil de discussion gardé le temps de la visite (sessionStorage),
   fiches produit renvoyées par le serveur avec bouton « Ajouter au panier » (panier latéral du thème). */
(function () {
  var racine = document.querySelector("[data-assistant]");
  if (!racine) return;
  var url = racine.getAttribute("data-url");
  var $ = function (s) { return racine.querySelector(s); };
  var bulle = $("[data-assistant-ouvrir]"), fenetre = $(".assistant__fenetre"), fil = $("[data-assistant-fil]");
  var form = $("[data-assistant-form]"), champ = form.querySelector("textarea"), suggestions = $("[data-assistant-suggestions]");
  var CLE = "to-assistant-fil", CLE_PRET = "to-assistant-pret";
  var stock = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  var historique = [];
  try { historique = JSON.parse(stock.get(CLE) || "[]"); } catch (e) { historique = []; }
  var esc = function (t) { return String(t == null ? "" : t).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var euros = function (x) { return Number(x).toFixed(2).replace(".", ",") + " €"; };
  var mise = function (t) { return esc(t).replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>").replace(/\n/g, "<br>"); };

  // La bulle n'apparaît que si le serveur est prêt (clé configurée). Réponse gardée 10 minutes.
  // 12 oct. 2026 : la vérification part 2 s après le chargement de la page (puis au premier moment de calme),
  // pour ne pas concurrencer le premier affichage ; à la première page vue, la bulle arrive donc un peu plus tard.
  var montrer = function () { racine.hidden = false; };
  // 1er nov. 2026 (benchmark P7) : sur toutes les pages, la bulle n'apparaît qu'après un demi-écran de défilement (classe a-defile,
  // déjà posée sur la fiche par test-or.js) : au premier écran de l'accueil et des collections, elle couvrait du texte.
  var defile = function () { document.body.classList.toggle("a-defile", window.scrollY > window.innerHeight * 0.5); };
  window.addEventListener("scroll", defile, { passive: true }); defile();
  var verifier = function () {
    fetch(url, { method: "GET" }).then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.pret) { stock.set(CLE_PRET, String(Date.now())); montrer(); }
    }).catch(function () {});
  };
  var plusTard = function () {
    setTimeout(function () {
      if (window.requestIdleCallback) requestIdleCallback(verifier, { timeout: 2000 }); else verifier();
    }, 2000);
  };
  var pret = stock.get(CLE_PRET);
  if (pret && Date.now() - parseInt(pret, 10) < 600000) montrer();
  else if (document.readyState === "complete") plusTard();
  else window.addEventListener("load", plusTard, { once: true });

  var carteHTML = function (c) {
    return '<div class="assistant__carte">' +
      (c.image ? '<a href="' + esc(c.url) + '" class="assistant__carte-img"><img src="' + esc(c.image) + (c.image.indexOf("?") > 0 ? "&" : "?") + 'width=200" alt="" width="72" height="72" loading="lazy"></a>' : "") +
      '<div class="assistant__carte-txt"><a href="' + esc(c.url) + '"><strong>' + esc(c.titre) + "</strong></a>" +
      (c.variante ? "<small>" + esc(c.variante) + "</small>" : "") +
      (c.argument ? "<p>" + esc(c.argument) + "</p>" : "") +
      '<div class="assistant__carte-bas"><b>' + euros(c.prix) + "</b>" +
      (c.dispo ? '<button type="button" class="btn btn--primary assistant__ajout" data-assistant-ajout="' + esc(c.variante_id) + '">Ajouter au panier</button>'
               : '<span class="assistant__rupture">Indisponible</span>') +
      "</div></div></div>";
  };
  var afficher = function (m) {
    var d = document.createElement("div");
    d.className = "assistant__msg assistant__msg--" + (m.role === "user" ? "client" : "bot");
    d.innerHTML = "<p>" + mise(m.content) + "</p>" + (m.cartes && m.cartes.length ? '<div class="assistant__cartes">' + m.cartes.map(carteHTML).join("") + "</div>" : "");
    fil.appendChild(d);
    fil.scrollTop = fil.scrollHeight;
  };
  historique.forEach(afficher);
  if (historique.length) suggestions.hidden = true;

  var ouvrir = function () {
    fenetre.hidden = false; bulle.setAttribute("aria-expanded", "true"); racine.classList.add("is-ouvert");
    setTimeout(function () { champ.focus(); fil.scrollTop = fil.scrollHeight; }, 50);
  };
  var fermer = function () { fenetre.hidden = true; bulle.setAttribute("aria-expanded", "false"); racine.classList.remove("is-ouvert"); bulle.focus(); };
  bulle.addEventListener("click", function () { if (fenetre.hidden) ouvrir(); else fermer(); });
  $("[data-assistant-fermer]").addEventListener("click", fermer);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !fenetre.hidden) fermer(); });

  var panier = function () {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart.js").then(function (r) { return r.json(); }).then(function (c) {
      return { total: (c.total_price / 100).toFixed(2), articles: c.items.map(function (i) { return { titre: i.product_title + (i.variant_title ? " · " + i.variant_title : ""), quantite: i.quantity, prix: (i.final_line_price / 100).toFixed(2) }; }) };
    }).catch(function () { return null; });
  };

  var occupe = false;
  var envoyer = function (texte) {
    texte = String(texte || "").trim();
    if (!texte || occupe) return;
    occupe = true; suggestions.hidden = true;
    var m = { role: "user", content: texte };
    historique.push(m); afficher(m);
    champ.value = ""; champ.style.height = "";
    var attente = document.createElement("div");
    attente.className = "assistant__msg assistant__msg--bot assistant__attente";
    attente.innerHTML = "<p><span></span><span></span><span></span></p>";
    fil.appendChild(attente); fil.scrollTop = fil.scrollHeight;
    panier().then(function (p) {
      // Le serveur ne reçoit que le texte ; les fiches déjà montrées sont résumées pour garder le contexte.
      var messages = historique.slice(-16).map(function (x) {
        return { role: x.role, content: x.content + (x.cartes && x.cartes.length ? "\n[Fiches montrées : " + x.cartes.map(function (c) { return c.titre + (c.variante ? " (" + c.variante + ")" : "") + " " + euros(c.prix); }).join(" ; ") + "]" : "") };
      });
      return fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ messages: messages, panier: p }) });
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (x) {
      attente.remove();
      var rep = x.ok ? { role: "assistant", content: x.j.texte, cartes: x.j.cartes || [] } : { role: "assistant", content: x.j.erreur || "Je n'arrive pas à répondre pour le moment." };
      historique.push(rep); afficher(rep);
      stock.set(CLE, JSON.stringify(historique.slice(-30)));
    }).catch(function () {
      attente.remove();
      afficher({ role: "assistant", content: "Connexion perdue. Réessayez dans un instant." });
    }).then(function () { occupe = false; });
  };

  form.addEventListener("submit", function (e) { e.preventDefault(); envoyer(champ.value); });
  champ.addEventListener("keydown", function (e) { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); envoyer(champ.value); } });
  champ.addEventListener("input", function () { champ.style.height = "auto"; champ.style.height = Math.min(champ.scrollHeight, 120) + "px"; });
  suggestions.addEventListener("click", function (e) { var b = e.target.closest("[data-assistant-suggestion]"); if (b) envoyer(b.textContent); });

  fil.addEventListener("click", function (e) {
    var b = e.target.closest("[data-assistant-ajout]");
    if (!b) return;
    var items = [{ id: parseInt(b.getAttribute("data-assistant-ajout"), 10), quantity: 1 }];
    b.setAttribute("aria-busy", "true");
    var fini = function () { b.removeAttribute("aria-busy"); b.textContent = "Ajouté ✓"; };
    if (window.TestOrPanier) { window.TestOrPanier.ajouter(items, b).then(fini, function () { b.removeAttribute("aria-busy"); }); return; }
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: items }) }).then(fini);
  });
})();
